// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Enhanced Auth Container */
.auth-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #FFFFFF 0%, #FFF7ED 60%, #FFEAD5 100%);
  padding: var(--space-8) var(--space-4);
  position: relative;
  overflow: hidden;
}

.auth-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background:
    radial-gradient(circle at 20% 80%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),
    radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),
    radial-gradient(circle at 40% 40%, rgba(255, 255, 255, 0.05) 0%, transparent 50%);
  pointer-events: none;
}

.auth-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: var(--radius-2xl);
  box-shadow:
    0 25px 50px -12px rgba(0, 0, 0, 0.25),
    0 0 0 1px rgba(255, 255, 255, 0.2);
  padding: var(--space-12);
  width: 100%;
  max-width: 480px;
  position: relative;
  z-index: 1;
  animation: slideUp 0.6s ease-out;
}

.signup-card {
  max-width: 500px;
}

.verification-card {
  max-width: 400px;
}

/* Verification Content */
.verification-content {
  text-align: center;
}

.verification-content h1 {
  color: var(--gray-900);
  font-size: var(--text-2xl);
  font-weight: var(--font-semibold);
  margin-bottom: var(--space-4);
}

.verification-content p {
  color: var(--gray-600);
  font-size: var(--text-base);
  line-height: var(--leading-relaxed);
  margin-bottom: var(--space-4);
}

.verification-content .email-display {
  font-weight: var(--font-medium);
  color: var(--primary-600);
  background: var(--primary-50);
  padding: var(--space-2) var(--space-4);
  border-radius: var(--radius-lg);
  display: inline-block;
  margin: var(--space-2) 0;
}

.verification-icon {
  margin: 0 auto var(--space-6);
  color: var(--primary-600);
}

.verification-icon.success {
  color: var(--success-500);
}

.verification-icon.error {
  color: var(--error-500);
}

.verification-actions {
  margin: var(--space-6) 0;
}

.verification-actions .resend-button {
  background: linear-gradient(135deg, #EA580C, #FDBA74);
  color: white;
  border: none;
  padding: var(--space-3) var(--space-6);
  border-radius: var(--radius-lg);
  font-size: var(--text-sm);
  font-weight: var(--font-medium);
  cursor: pointer;
  transition: all var(--transition-normal);
}

.verification-actions .resend-button:hover:not(:disabled) {
  background: linear-gradient(135deg, #C2410C, #FB923C);
  transform: translateY(-1px);
}

.verification-actions .resend-button:disabled {
  background: var(--gray-400);
  cursor: not-allowed;
  transform: none;
}

/* Auth Header */
.auth-header {
  text-align: center;
  margin-bottom: 2rem;
}

.auth-header h1 {
  color: #2c3e50;
  font-size: 2rem;
  font-weight: 700;
  margin: 0 0 0.5rem 0;
}

.auth-header p {
  color: #7f8c8d;
  font-size: 1rem;
  margin: 0;
  line-height: 1.5;
}

.auth-logo {
  height: 60px;
  width: auto;
  max-width: 200px;
  object-fit: contain;
  margin-bottom: 1rem;
  border-radius: 8px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

/* Ensure logo container is centered on auth pages */
.auth-header .logo-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1rem;
}

/* Center content in verification pages */
.verification-content {
  text-align: center;
}

.verification-content .auth-header {
  margin-bottom: 2rem;
}

.email-display {
  font-weight: 600;
  color: #2c3e50 !important;
  margin: 0.5rem 0 !important;
}

/* Icons */
.verification-icon,
.success-icon {
  display: flex;
  justify-content: center;
  margin-bottom: 1.5rem;
  color: #27ae60;
}

.success-icon {
  color: #27ae60;
}

/* Form Styles */
.auth-form {
  margin-bottom: 2rem;
}

/* Form Groups - Now using global styles from design-system.css */

.form-group input.error {
  border-color: #e74c3c;
}

.form-group input.error:focus {
  border-color: #e74c3c;
  box-shadow: 0 0 0 3px rgba(231, 76, 60, 0.1);
}

.verification-input {
  text-align: center;
  font-size: 1.5rem;
  letter-spacing: 0.5rem;
  font-weight: 600;
}

/* Checkbox Styles */
.checkbox-group {
  margin-bottom: 1.5rem;
}

.checkbox-label {
  display: flex;
  align-items: flex-start;
  cursor: pointer;
  font-size: 0.9rem;
  line-height: 1.4;
}

.checkbox-label input[type="checkbox"] {
  width: auto;
  margin-right: 0.75rem;
  margin-top: 0.2rem;
}

.checkbox-label a {
  color: #0D3B66;
  text-decoration: none;
}

.checkbox-label a:hover {
  text-decoration: underline;
}

/* Form Options */
.form-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
  gap: 1rem;
}

.forgot-link {
  color: #0D3B66;
  text-decoration: none;
  font-size: 0.9rem;
}

.forgot-link:hover {
  text-decoration: underline;
}

/* Buttons */
.auth-button {
  width: 100%;
  background: linear-gradient(135deg, #EA580C, #FDBA74);
  color: white;
  border: none;
  padding: 1rem;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-bottom: 1rem;
}

.auth-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(234, 88, 12, 0.3);
}

.auth-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.auth-button.secondary {
  background: #FFFFFF;
  border: 1px solid #E5E7EB;
  color: #0D3B66;
}

.auth-button.secondary:hover:not(:disabled) {
  background: #F7F7F8;
  box-shadow: 0 8px 20px rgba(13, 59, 102, 0.2);
}

/* Resend Button */
.resend-button {
  background: none;
  border: 2px solid #EA580C;
  color: #EA580C;
  padding: 0.75rem 1.5rem;
  border-radius: 6px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin: 1rem 0;
}

.resend-button:hover:not(:disabled) {
  background: #EA580C;
  color: white;
}

.resend-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Error Messages */
.error-message {
  background: #fdf2f2;
  color: #e74c3c;
  padding: 1rem;
  border-radius: 6px;
  margin-bottom: 1rem;
  border-left: 4px solid #e74c3c;
  font-size: 0.9rem;
}

.field-error {
  color: #e74c3c;
  font-size: 0.8rem;
  margin-top: 0.5rem;
  display: block;
}

/* Success Message */
.success-message {
  background: #f0f9ff;
  color: #2c3e50;
  padding: 1.5rem;
  border-radius: 8px;
  margin: 1.5rem 0;
  border-left: 4px solid #27ae60;
  text-align: center;
}

.success-message p {
  margin: 0.5rem 0;
  line-height: 1.5;
}

/* Auth Footer */
.auth-footer {
  text-align: center;
  padding-top: 1rem;
  border-top: 1px solid #e1e8ed;
}

.auth-footer p {
  color: #7f8c8d;
  font-size: 0.9rem;
  margin: 0.5rem 0;
}

.auth-footer a {
  color: #3498db;
  text-decoration: none;
  font-weight: 600;
}

.auth-footer a:hover {
  text-decoration: underline;
}

/* Verification Footer */
.verification-footer {
  text-align: center;
  padding-top: 1rem;
  border-top: 1px solid #e1e8ed;
}

.verification-footer p {
  color: #7f8c8d;
  font-size: 0.9rem;
  margin: 0.5rem 0;
}

.verification-links {
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;
}

.verification-links a {
  color: #3498db;
  text-decoration: none;
  font-size: 0.9rem;
}

.verification-links a:hover {
  text-decoration: underline;
}

/* Modal Styles */
/* Modal Overlay - Now using global styles from design-system.css */

.modal-content {
  background: white;
  border-radius: 12px;
  padding: 2rem;
  max-width: 400px;
  width: 90%;
  text-align: center;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
}

.modal-content h3 {
  color: #2c3e50;
  margin: 0 0 1rem 0;
  font-size: 1.3rem;
}

.modal-content p {
  color: #7f8c8d;
  margin: 0 0 1.5rem 0;
  line-height: 1.5;
}

.modal-actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
}

.modal-actions .auth-button {
  flex: 1 1;
  min-width: 120px;
  margin: 0;
}

/* Enhanced Elderly-Friendly Styles */
.auth-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
  padding: 3.5rem;
  width: 100%;
  max-width: 480px;
  position: relative;
}

.auth-header h1 {
  color: #2c3e50;
  font-size: 2.2rem;
  font-weight: 700;
  margin: 0 0 0.5rem 0;
  letter-spacing: -0.5px;
}

.form-group input {
  width: 100%;
  padding: 1.2rem;
  border: 3px solid #e1e8ed;
  border-radius: 12px;
  font-size: 1.1rem;
  transition: all 0.3s ease;
  box-sizing: border-box;
  background-color: #fafbfc;
}

.form-group input:focus {
  outline: none;
  border-color: #3498db;
  box-shadow: 0 0 0 4px rgba(52, 152, 219, 0.15);
  background-color: white;
}

.auth-button {
  width: 100%;
  background: linear-gradient(135deg, var(--primary-600), var(--primary-700));
  color: white;
  border: none;
  padding: 1.2rem;
  border-radius: 12px;
  font-size: 1.1rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-bottom: 1rem;
  letter-spacing: 0.5px;
}

.auth-button:hover:not(:disabled) {
  transform: translateY(-3px);
  box-shadow: 0 12px 25px rgba(67, 56, 202, 0.4);
}

/* Responsive Design */
@media (max-width: 768px) {
  .auth-container {
    padding: 1rem;
  }

  .auth-card {
    padding: 2.5rem;
    max-width: 100%;
  }

  .form-row {
    grid-template-columns: 1fr;
  }

  .verification-links {
    flex-direction: column;
    gap: 0.5rem;
  }

  .auth-header h1 {
    font-size: 1.8rem;
  }

  .form-options {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
  }

  .modal-actions {
    flex-direction: column;
  }

  .modal-actions .auth-button {
    min-width: 100%;
  }
}

/* User Info Display */
.user-info {
  margin: 1rem 0;
  padding: 1rem;
  background: #e8f5e8;
  border-radius: 8px;
  border-left: 4px solid #27ae60;
}

.user-info p {
  margin: 0.25rem 0;
  color: #2c3e50;
  font-size: 0.95rem;
}

.user-info strong {
  color: #27ae60;
  font-weight: 600;
}

/* Password Requirements */
.password-requirements {
  margin-top: 1rem;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 8px;
  border-left: 4px solid #3498db;
}

.password-requirements h4 {
  color: #2c3e50;
  margin: 0 0 0.75rem 0;
  font-size: 0.95rem;
  font-weight: 600;
}

.password-requirements ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.password-requirements li {
  color: #7f8c8d;
  font-size: 0.85rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: color 0.3s ease;
}

.password-requirements li::before {
  content: '✗';
  color: #e74c3c;
  font-weight: bold;
  font-size: 0.9rem;
  transition: color 0.3s ease;
}

.password-requirements li.valid {
  color: #27ae60;
}

.password-requirements li.valid::before {
  content: '✓';
  color: #27ae60;
}

@media (max-width: 480px) {
  .auth-card {
    padding: 1.5rem;
  }

  .verification-input {
    font-size: 1.2rem;
    letter-spacing: 0.3rem;
  }

  .password-requirements {
    padding: 0.75rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/auth/Auth.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0EAA0E;EAC1E,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;;qFAGmF;EACnF,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,gCAAgC;EAChC;;sCAEoC;EACpC,wBAAwB;EACxB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,6BAA6B;EAC7B,sCAAsC;EACtC,+BAA+B;EAC/B,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,sCAAsC;EACtC,+BAA+B;EAC/B,yBAAyB;EACzB,+BAA+B;EAC/B,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,yCAAyC;AACzC;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,UAAU;AACV;;EAEE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;AACrB;;AAEA,iEAAiE;;AAEjE;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,iBAAiB;AACjB,mEAAmE;;AAEnE;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,SAAS;AACX;;AAEA,qCAAqC;AACrC;EACE,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;EAC3C,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;EAC9C,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,2EAA2E;EAC3E,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,sBAAsB;AACtB;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/* Enhanced Auth Container */\n.auth-container {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #FFFFFF 0%, #FFF7ED 60%, #FFEAD5 100%);\n  padding: var(--space-8) var(--space-4);\n  position: relative;\n  overflow: hidden;\n}\n\n.auth-container::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background:\n    radial-gradient(circle at 20% 80%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),\n    radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),\n    radial-gradient(circle at 40% 40%, rgba(255, 255, 255, 0.05) 0%, transparent 50%);\n  pointer-events: none;\n}\n\n.auth-card {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-radius: var(--radius-2xl);\n  box-shadow:\n    0 25px 50px -12px rgba(0, 0, 0, 0.25),\n    0 0 0 1px rgba(255, 255, 255, 0.2);\n  padding: var(--space-12);\n  width: 100%;\n  max-width: 480px;\n  position: relative;\n  z-index: 1;\n  animation: slideUp 0.6s ease-out;\n}\n\n.signup-card {\n  max-width: 500px;\n}\n\n.verification-card {\n  max-width: 400px;\n}\n\n/* Verification Content */\n.verification-content {\n  text-align: center;\n}\n\n.verification-content h1 {\n  color: var(--gray-900);\n  font-size: var(--text-2xl);\n  font-weight: var(--font-semibold);\n  margin-bottom: var(--space-4);\n}\n\n.verification-content p {\n  color: var(--gray-600);\n  font-size: var(--text-base);\n  line-height: var(--leading-relaxed);\n  margin-bottom: var(--space-4);\n}\n\n.verification-content .email-display {\n  font-weight: var(--font-medium);\n  color: var(--primary-600);\n  background: var(--primary-50);\n  padding: var(--space-2) var(--space-4);\n  border-radius: var(--radius-lg);\n  display: inline-block;\n  margin: var(--space-2) 0;\n}\n\n.verification-icon {\n  margin: 0 auto var(--space-6);\n  color: var(--primary-600);\n}\n\n.verification-icon.success {\n  color: var(--success-500);\n}\n\n.verification-icon.error {\n  color: var(--error-500);\n}\n\n.verification-actions {\n  margin: var(--space-6) 0;\n}\n\n.verification-actions .resend-button {\n  background: linear-gradient(135deg, #EA580C, #FDBA74);\n  color: white;\n  border: none;\n  padding: var(--space-3) var(--space-6);\n  border-radius: var(--radius-lg);\n  font-size: var(--text-sm);\n  font-weight: var(--font-medium);\n  cursor: pointer;\n  transition: all var(--transition-normal);\n}\n\n.verification-actions .resend-button:hover:not(:disabled) {\n  background: linear-gradient(135deg, #C2410C, #FB923C);\n  transform: translateY(-1px);\n}\n\n.verification-actions .resend-button:disabled {\n  background: var(--gray-400);\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Auth Header */\n.auth-header {\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n.auth-header h1 {\n  color: #2c3e50;\n  font-size: 2rem;\n  font-weight: 700;\n  margin: 0 0 0.5rem 0;\n}\n\n.auth-header p {\n  color: #7f8c8d;\n  font-size: 1rem;\n  margin: 0;\n  line-height: 1.5;\n}\n\n.auth-logo {\n  height: 60px;\n  width: auto;\n  max-width: 200px;\n  object-fit: contain;\n  margin-bottom: 1rem;\n  border-radius: 8px;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n/* Ensure logo container is centered on auth pages */\n.auth-header .logo-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n\n/* Center content in verification pages */\n.verification-content {\n  text-align: center;\n}\n\n.verification-content .auth-header {\n  margin-bottom: 2rem;\n}\n\n.email-display {\n  font-weight: 600;\n  color: #2c3e50 !important;\n  margin: 0.5rem 0 !important;\n}\n\n/* Icons */\n.verification-icon,\n.success-icon {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 1.5rem;\n  color: #27ae60;\n}\n\n.success-icon {\n  color: #27ae60;\n}\n\n/* Form Styles */\n.auth-form {\n  margin-bottom: 2rem;\n}\n\n/* Form Groups - Now using global styles from design-system.css */\n\n.form-group input.error {\n  border-color: #e74c3c;\n}\n\n.form-group input.error:focus {\n  border-color: #e74c3c;\n  box-shadow: 0 0 0 3px rgba(231, 76, 60, 0.1);\n}\n\n.verification-input {\n  text-align: center;\n  font-size: 1.5rem;\n  letter-spacing: 0.5rem;\n  font-weight: 600;\n}\n\n/* Checkbox Styles */\n.checkbox-group {\n  margin-bottom: 1.5rem;\n}\n\n.checkbox-label {\n  display: flex;\n  align-items: flex-start;\n  cursor: pointer;\n  font-size: 0.9rem;\n  line-height: 1.4;\n}\n\n.checkbox-label input[type=\"checkbox\"] {\n  width: auto;\n  margin-right: 0.75rem;\n  margin-top: 0.2rem;\n}\n\n.checkbox-label a {\n  color: #0D3B66;\n  text-decoration: none;\n}\n\n.checkbox-label a:hover {\n  text-decoration: underline;\n}\n\n/* Form Options */\n.form-options {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.forgot-link {\n  color: #0D3B66;\n  text-decoration: none;\n  font-size: 0.9rem;\n}\n\n.forgot-link:hover {\n  text-decoration: underline;\n}\n\n/* Buttons */\n.auth-button {\n  width: 100%;\n  background: linear-gradient(135deg, #EA580C, #FDBA74);\n  color: white;\n  border: none;\n  padding: 1rem;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin-bottom: 1rem;\n}\n\n.auth-button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(234, 88, 12, 0.3);\n}\n\n.auth-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.auth-button.secondary {\n  background: #FFFFFF;\n  border: 1px solid #E5E7EB;\n  color: #0D3B66;\n}\n\n.auth-button.secondary:hover:not(:disabled) {\n  background: #F7F7F8;\n  box-shadow: 0 8px 20px rgba(13, 59, 102, 0.2);\n}\n\n/* Resend Button */\n.resend-button {\n  background: none;\n  border: 2px solid #EA580C;\n  color: #EA580C;\n  padding: 0.75rem 1.5rem;\n  border-radius: 6px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin: 1rem 0;\n}\n\n.resend-button:hover:not(:disabled) {\n  background: #EA580C;\n  color: white;\n}\n\n.resend-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Error Messages */\n.error-message {\n  background: #fdf2f2;\n  color: #e74c3c;\n  padding: 1rem;\n  border-radius: 6px;\n  margin-bottom: 1rem;\n  border-left: 4px solid #e74c3c;\n  font-size: 0.9rem;\n}\n\n.field-error {\n  color: #e74c3c;\n  font-size: 0.8rem;\n  margin-top: 0.5rem;\n  display: block;\n}\n\n/* Success Message */\n.success-message {\n  background: #f0f9ff;\n  color: #2c3e50;\n  padding: 1.5rem;\n  border-radius: 8px;\n  margin: 1.5rem 0;\n  border-left: 4px solid #27ae60;\n  text-align: center;\n}\n\n.success-message p {\n  margin: 0.5rem 0;\n  line-height: 1.5;\n}\n\n/* Auth Footer */\n.auth-footer {\n  text-align: center;\n  padding-top: 1rem;\n  border-top: 1px solid #e1e8ed;\n}\n\n.auth-footer p {\n  color: #7f8c8d;\n  font-size: 0.9rem;\n  margin: 0.5rem 0;\n}\n\n.auth-footer a {\n  color: #3498db;\n  text-decoration: none;\n  font-weight: 600;\n}\n\n.auth-footer a:hover {\n  text-decoration: underline;\n}\n\n/* Verification Footer */\n.verification-footer {\n  text-align: center;\n  padding-top: 1rem;\n  border-top: 1px solid #e1e8ed;\n}\n\n.verification-footer p {\n  color: #7f8c8d;\n  font-size: 0.9rem;\n  margin: 0.5rem 0;\n}\n\n.verification-links {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 1rem;\n}\n\n.verification-links a {\n  color: #3498db;\n  text-decoration: none;\n  font-size: 0.9rem;\n}\n\n.verification-links a:hover {\n  text-decoration: underline;\n}\n\n/* Modal Styles */\n/* Modal Overlay - Now using global styles from design-system.css */\n\n.modal-content {\n  background: white;\n  border-radius: 12px;\n  padding: 2rem;\n  max-width: 400px;\n  width: 90%;\n  text-align: center;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);\n}\n\n.modal-content h3 {\n  color: #2c3e50;\n  margin: 0 0 1rem 0;\n  font-size: 1.3rem;\n}\n\n.modal-content p {\n  color: #7f8c8d;\n  margin: 0 0 1.5rem 0;\n  line-height: 1.5;\n}\n\n.modal-actions {\n  display: flex;\n  gap: 1rem;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.modal-actions .auth-button {\n  flex: 1;\n  min-width: 120px;\n  margin: 0;\n}\n\n/* Enhanced Elderly-Friendly Styles */\n.auth-card {\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);\n  padding: 3.5rem;\n  width: 100%;\n  max-width: 480px;\n  position: relative;\n}\n\n.auth-header h1 {\n  color: #2c3e50;\n  font-size: 2.2rem;\n  font-weight: 700;\n  margin: 0 0 0.5rem 0;\n  letter-spacing: -0.5px;\n}\n\n.form-group input {\n  width: 100%;\n  padding: 1.2rem;\n  border: 3px solid #e1e8ed;\n  border-radius: 12px;\n  font-size: 1.1rem;\n  transition: all 0.3s ease;\n  box-sizing: border-box;\n  background-color: #fafbfc;\n}\n\n.form-group input:focus {\n  outline: none;\n  border-color: #3498db;\n  box-shadow: 0 0 0 4px rgba(52, 152, 219, 0.15);\n  background-color: white;\n}\n\n.auth-button {\n  width: 100%;\n  background: linear-gradient(135deg, var(--primary-600), var(--primary-700));\n  color: white;\n  border: none;\n  padding: 1.2rem;\n  border-radius: 12px;\n  font-size: 1.1rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin-bottom: 1rem;\n  letter-spacing: 0.5px;\n}\n\n.auth-button:hover:not(:disabled) {\n  transform: translateY(-3px);\n  box-shadow: 0 12px 25px rgba(67, 56, 202, 0.4);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .auth-container {\n    padding: 1rem;\n  }\n\n  .auth-card {\n    padding: 2.5rem;\n    max-width: 100%;\n  }\n\n  .form-row {\n    grid-template-columns: 1fr;\n  }\n\n  .verification-links {\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n\n  .auth-header h1 {\n    font-size: 1.8rem;\n  }\n\n  .form-options {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.75rem;\n  }\n\n  .modal-actions {\n    flex-direction: column;\n  }\n\n  .modal-actions .auth-button {\n    min-width: 100%;\n  }\n}\n\n/* User Info Display */\n.user-info {\n  margin: 1rem 0;\n  padding: 1rem;\n  background: #e8f5e8;\n  border-radius: 8px;\n  border-left: 4px solid #27ae60;\n}\n\n.user-info p {\n  margin: 0.25rem 0;\n  color: #2c3e50;\n  font-size: 0.95rem;\n}\n\n.user-info strong {\n  color: #27ae60;\n  font-weight: 600;\n}\n\n/* Password Requirements */\n.password-requirements {\n  margin-top: 1rem;\n  padding: 1rem;\n  background: #f8f9fa;\n  border-radius: 8px;\n  border-left: 4px solid #3498db;\n}\n\n.password-requirements h4 {\n  color: #2c3e50;\n  margin: 0 0 0.75rem 0;\n  font-size: 0.95rem;\n  font-weight: 600;\n}\n\n.password-requirements ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.password-requirements li {\n  color: #7f8c8d;\n  font-size: 0.85rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  transition: color 0.3s ease;\n}\n\n.password-requirements li::before {\n  content: '✗';\n  color: #e74c3c;\n  font-weight: bold;\n  font-size: 0.9rem;\n  transition: color 0.3s ease;\n}\n\n.password-requirements li.valid {\n  color: #27ae60;\n}\n\n.password-requirements li.valid::before {\n  content: '✓';\n  color: #27ae60;\n}\n\n@media (max-width: 480px) {\n  .auth-card {\n    padding: 1.5rem;\n  }\n\n  .verification-input {\n    font-size: 1.2rem;\n    letter-spacing: 0.3rem;\n  }\n\n  .password-requirements {\n    padding: 0.75rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
